import { render, staticRenderFns } from "./NoPermissionSection.vue?vue&type=template&id=421512dd&scoped=true&"
import script from "./NoPermissionSection.vue?vue&type=script&lang=js&"
export * from "./NoPermissionSection.vue?vue&type=script&lang=js&"
import style0 from "./NoPermissionSection.vue?vue&type=style&index=0&id=421512dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421512dd",
  null
  
)

export default component.exports